var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckWithoudBg = function SvgCheckWithoudBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.233.426a.562.562 0 0 1-.022.795l-5.35 5.958a1.296 1.296 0 0 1-1.771 0L.425 4.65a.563.563 0 0 1 .775-.816l2.664 2.527a.162.162 0 0 0 .112.042.162.162 0 0 0 .112-.042L9.438.404a.563.563 0 0 1 .795.022Z",
    fill: "#F6FAFF"
  })));
};
export default SvgCheckWithoudBg;